function parse(hex: string): [number, number, number] {
  const v = hex.replace("#", "");
  return [parseInt(v.slice(0, 2), 16), parseInt(v.slice(2, 4), 16), parseInt(v.slice(4, 6), 16)];
}

export function isLight(hex: string): boolean {
  const [r, g, b] = parse(hex);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150;
}

/** Mix a color toward black (negative amount) or white (positive amount). */
export function shade(hex: string, amount: number): string {
  const target = amount < 0 ? 0 : 255;
  const p = Math.abs(amount);
  const [r, g, b] = parse(hex).map((c) => Math.round(c + (target - c) * p));
  return `rgb(${r}, ${g}, ${b})`;
}

export function contrastInk(hex: string): string {
  return isLight(hex) ? "#0A0A0A" : "#FFFFFF";
}
